module.exports = "<h2 id=\"description\">Description</h2>\n<blockquote>\n<p>Open your console to see which data you can use when you hover a point</p>\n</blockquote>\n<p>The following props are disabled for the demo but can be customizable:</p>\n<ul>\n<li>data</li>\n<li>labelsCharacterWidth</li>\n<li>labelsFormatX</li>\n<li>labelsFormatY</li>\n<li>labelsHeightX</li>\n<li>labelsOffsetX</li>\n<li>labelsOffsetY</li>\n<li>pathSmoothing</li>\n<li>pointsIsHoverOnZone</li>\n<li>onHover</li>\n</ul>\n<h2 id=\"demo\">Demo</h2>\n";


//////////////////
// WEBPACK FOOTER
// ./demo/src/demo.md
// module id = ./demo/src/demo.md
// module chunks = 0